import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, interval } from 'rxjs';

@Injectable()
export class LoaderService {
  private saLoaderSubject = new Subject<any>();
  private counterSubject = new BehaviorSubject<number>(0); // Emits counter values

  public saLoaderState = this.saLoaderSubject.asObservable();
  public counterState = this.counterSubject.asObservable(); // Observable for the counter

  private counter = 0; // Counter value
  private intervalId: any; // To keep track of the interval

  constructor() {}

  show() {
    this.counter = 0;
    this.counterSubject.next(this.counter); // Emit the initial value

    // Start emitting counter values every second
    this.intervalId = setInterval(() => {
      this.counter++;
      this.counterSubject.next(this.counter); // Emit updated counter
    }, 1000);

    this.saLoaderSubject.next({
      show: true
    });
  }

  hide() {
    // Stop the counter interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.saLoaderSubject.next({
      show: false
    });
  }
}


